var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "14px",
    viewBox: "0 0 10 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Location Filled") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.34,0 C6.71596193,0 8.68,1.75796988 8.68,4.28096544 C8.68,5.19463412 8.4209229,6.17199243 8.001875,6.90701807 L4.6212963,12.8379447 C4.56466327,12.9388674 4.45694248,13.0014999 4.34,13.0014999 C4.22305752,13.0014999 4.11533673,12.9388674 4.0587037,12.8379447 L0.678125,6.90701807 C0.259093178,6.17202414 0,5.19463412 0,4.28096544 C0,1.75796988 1.96403807,0 4.34,0 Z M4.34,2.21975904 C3.18973283,2.21975904 2.25037037,3.14636573 2.25037037,4.28096544 C2.25037037,5.41557942 3.18973604,6.34216867 4.34,6.34216867 C5.49026396,6.34216867 6.42962963,5.41557942 6.42962963,4.28096544 C6.42962963,3.14636573 5.49026717,2.21975904 4.34,2.21975904 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RHP-Search--Desktop-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile-5-Friend-Request",
    transform: "translate(-1051.000000, -1001.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Datefinder",
    transform: "translate(1019.000000, 932.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(30.000000, 67.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Location-Filled",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/mid-grey",
    transform: "translate(2.800000, 0.560000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/black",
    mask: "url(#mask-2)",
    fill: "#7bcb45"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.800000, -0.560000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 14,
    height: 14
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationGreen);
export default __webpack_public_path__ + "static/media/locationGreen.c027b258538b2bdf5fa6ba231a2323ef.svg";
export { ForwardRef as ReactComponent };